import { Text, TextProps } from "@chakra-ui/react";

const Title = ({...rest}: TextProps) => {
  return (
    <Text
      fontFamily="VivoType"
      fontWeight={"500"}
      fontSize={{base: "18px", lg:"20px"}}
      lineHeight={{base: "24px", lg: "28px"}}
      color={"white"}
      {...rest}
    />
  );
};

export default Title;
